import React from 'react';
import Modal from 'react-modal';
import { connect } from 'react-redux';
import SVG from 'react-inlinesvg';
import MaskedInput from 'react-text-mask';
import axios from 'axios';

import './index.css';
import { toggleFormsModal } from '../../actions';
import Button from '../button';
import closeModal from '../../images/vacancies/closeModal.svg';
import downloadIcon from '../../images/download.svg';
import qrCode from '../../images/mobile/qr-code.svg';
import deleteIcon from '../../images/file-delete.svg';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    padding: '0',
    maxHeight: "calc(100vh - 40px)",
    overflowY: "scroll",
    overflowX: 'hidden'
  },
  overlay: {
    position: "fixed",
    top: "0px",
    left: "0px",
    right: "0px",
    bottom: "0px",
    backgroundColor: "rgba(0,0,0,.2)",
    zIndex: '100'
  }
};

Modal.setAppElement('#root');

class FormsModal extends React.Component {
  state = {
    filter: 'web',
    filename: null,
    idea: {
      phone: '',
      comment: '',
      name: '',
      file: null,
      touched: {
        phone: false,
        comment: false,
        name: false
      },
      valid: {
        phone: false,
        name: false
      }
    },
    join: {
      phone: '',
      email: '',
      name: '',
      prof: 'Frontend',
      file: null,
      touched: {
        phone: false,
        email: false,
        name: false,
        prof: true
      },
      valid: {
        phone: false,
        name: false,
        email: false,
        prof: true
      }
    }
  }

  handleTouched = (form, label) => {
    let touched = {
      ...this.state[form].touched,
      [label]: true
    }
    this.setState({
      [form]: {
        ...this.state[form],
        touched
      }
    })
  }

  handleInput = (e, form, label) => {
    this.setState({
      [form]: {
        ...this.state[form],
        [label]: e.target.value
      }
    }, () => this.checkInputsValidity(form))
  }

  checkInputsValidity = (form) => {
    const phonePattern = /[+][7][ ][(]\d\d\d[)][ ]\d\d\d[-]\d\d\d\d/;
    const emailPattern = /^[a-z0-9_-]+@[a-z0-9-]+\.[a-z]{2,6}$/i;

    if (form === 'idea') {
      this.setState({
        [form]: {
          ...this.state.idea,
          valid: {
            phone: phonePattern.test(this.state.idea.phone),
            name: this.state.idea.name.length > 1
          }
        }
      })
    } else if (form === 'join') {
      this.setState({
        [form]: {
          ...this.state.join,
          valid: {
            phone: phonePattern.test(this.state.join.phone),
            name: this.state.join.name.length > 1,
            email: emailPattern.test(this.state.join.email)
          }
        }
      })
    }

  }

  formIsValid = () => {
    return Object.values(this.state[this.props.formsModalTab].valid)
      .filter(validity => validity === true).length === Object.values(this.state[this.props.formsModalTab].valid).length;
  }

  submitApplication = (event) => {
    event.preventDefault();
    if (this.props.formsModalTab === 'idea') {
      if (this.formIsValid()) {
        const IdeaForm = {
          user: this.state.idea.name,
          phone: this.state.idea.phone,
          text: this.state.idea.comment,
          file: this.state.idea.file
        }

         let data = new FormData(IdeaForm);
         data.append("user", IdeaForm.user);
         data.append("phone", IdeaForm.phone);
         data.append("text", IdeaForm.comment);
         data.append("file", IdeaForm.file);
        axios.post("/api/v1/sendmail/idea", data)
          .then(response => {
            console.log(response);
            this.closeModal();

          });

      }
    }
    else if (this.props.formsModalTab === 'join') {
      if (this.formIsValid()) {
        const joinForm = {
          user: this.state.join.name,
          phone: this.state.join.phone,
          prof: this.state.join.prof,
          email: this.state.join.email,
          file: this.state.join.file
        }
        let data = new FormData();
        data.append("user", joinForm.user);
        data.append("phone", joinForm.phone);
        data.append("prof", joinForm.prof);
        data.append("email", joinForm.email);
        data.append("file", joinForm.file);
        axios.post("/api/v1/sendmail/join", data)
          .then(response => {console.log(response)
          });
      this.props.toggleFormsModal(true, 'thanksPage')

      }
    }
  }
  handleFileInput = (event, form) => {
    event.persist();
    this.setState({
      [form]:
      {
        ...this.state[form],
        file: event.target.files[0]
      },
      filename: event.target.files[0].name
    });
  }

  handleFileDelete = (form) => {
    this.setState({ form: { ...this.state[form], file: null }, filename: null })
    document.getElementById("file").value = "";
  }

  closeModal = () => {
    this.props.toggleFormsModal(false);
  }

  handleFilter = (filter) => {
    this.setState({ filter })
  }

  handleFormsTab = (tab) => {
    switch (tab) {
      case 'idea':
        return (<div className="formsModal__idea">
          <div
            className="formsModal__idea__close"
            onClick={this.closeModal}>
            <SVG src={closeModal} />
          </div>
          <h2 className="formsModal__idea__title">{localStorage.getItem('lang') == 'ru'? 'Рассчитать проект':'Calculate project'}</h2>
          <p className="formsModal__idea__description">{localStorage.getItem('lang') == 'ru'? 'Оставьте заявку и менеджер свяжется с Вами в самое ближайшее время':'Leave a request and the manager will contact you shortly'}</p>
          <div className="formsModal__idea__filters">
            <h4 className="formsModal__idea__filters__title">{localStorage.getItem('lang') == 'ru'? 'Что вас интересует?':'What are you interested in?'}</h4>
            <div className="formsModal__idea__filters__wrapper">
              <div
                className={["formsModal__idea__filters__item",
                  this.state.filter === 'web' ? "formsModal__idea__filters__item-active" : ""].join(" ")}
                onClick={() => this.handleFilter('web')}>
                  {localStorage.getItem('lang') == 'ru'? 'Веб-приложение, сайт':'Web application, website'}
            </div>
              <div
                className={["formsModal__idea__filters__item",
                  this.state.filter === 'mobile' ? "formsModal__idea__filters__item-active" : ""].join(" ")}
                onClick={() => this.handleFilter('mobile')}>
                  {localStorage.getItem('lang') == 'ru'? 'Мобильное приложение':'Mobile app'}
            </div>
            </div>
            <form className="formsModal__idea__inputs">
              <h4 className="formsModal__idea__filters__title">{localStorage.getItem('lang') == 'ru'? 'Контактная информация':'Contact Information'}</h4>
              <input
                type="text"
                className={["formsModal__idea__input", this.state.idea.touched.name && !this.state.idea.valid.name ? "idea__input-invalid" : " "].join(" ")}
                placeholder="Имя"
                onChange={(e) => this.handleInput(e, 'idea', 'name')}
                onBlur={() => this.handleTouched('idea', 'name')} />
              <MaskedInput
                mask={['+', '7', ' ', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                showMask={true}
                keepCharPositions={false}
                onChange={(e) => this.handleInput(e, 'idea', 'phone')}
                onBlur={() => this.handleTouched('idea', 'phone')}
                type="tel"
                className={["formsModal__idea__input", this.state.idea.touched.phone && !this.state.idea.valid.phone ? "idea__input-invalid" : " "].join(" ")}
                placeholder={localStorage.getItem('lang') == 'ru'? 'Телефон':'Phone'}
              />
              <textarea
                className="formsModal__idea__comment"
                placeholder={localStorage.getItem('lang') == 'ru'? 'Расскажите о вашей идее':'Tell us about your idea.'}
                onChange={(e) => this.handleInput(e, 'idea', 'comment')}>
              </textarea>
              <div className={["idea__download__content idea__input-file__wrapper"].join(" ")}>
                <div className={["idea__input-file__button", this.props.theme === 'dark' ? "idea__input-file__button-dark" : ""].join(" ")}>
                  {localStorage.getItem('lang') == 'ru'? 'Загрузить файл':'Upload file'}
                  </div>

                <img className="idea__download__content-contact" src={downloadIcon} alt="download arrow" />
                <input
                  type="file"
                  name="file"
                  className="formsModal__idea__input-file"
                  onChange={(e) => this.handleFileInput(e, 'idea')} />
                {this.state.filename ?
                  <span className={["idea__input-file__name", this.props.theme === 'dark' ? "idea__input-file__name-dark" : ""].join(" ")}>{this.state.filename}</span> :
                  <span className={["idea__input-file__name", this.props.theme === 'dark' ? "idea__input-file__name-dark" : ""].join(" ")}>{localStorage.getItem('lang') == 'ru'? 'Выберите файл':'Select a file'}</span>}
                {this.state.filename ?
                  <div
                    onClick={() => this.handleFileDelete('idea')}
                    className={["idea__download__content__delete", this.props.theme === 'dark' ? "idea__download__content__delete-dark" : ""].join(" ")} >
                    <SVG src={deleteIcon} />
                  </div> : null
                }
              </div>
            </form>
            <div className="formsModal__idea__buttons">
              <Button handler={this.submitApplication}>{localStorage.getItem('lang') == 'ru'? 'Отправить':'Send'}</Button>
            </div>
          </div>
        </div>)
      case 'join':
        return (<div className="formsModal__join">
          <div
            className="formsModal__idea__close"
            onClick={this.closeModal}>
            <SVG src={closeModal} />
          </div>
          <h2 className="formsModal__join__title">{localStorage.getItem('lang') == 'ru'? 'Стань частью команды LeoTrado':'Become a part of the LeoTrado Team'}</h2>
          <p className="formsModal__join__description">{localStorage.getItem('lang') == 'ru'? 'Если хочешь участвовать в сложных проектах, взаимодействовать в большой дружной команде - присоединяйтесь к нам!':
          'If you want to participate in complex projects, interact in a large friendly team - join us!'}</p>
          <form className="formsModal__join__input-wrapper" onSubmit={this.handleSuccess}>
            <input
              className={["formsModal__idea__input", this.state.join.touched.name && !this.state.join.valid.name ? "idea__input-invalid" : " "].join(" ")}
              type="text"
              name="username"
              required
              placeholder={localStorage.getItem('lang') == 'ru'? 'Имя':'Name'}
              onChange={(e) => this.handleInput(e, 'join', 'name')}
              onBlur={() => this.handleTouched('join', 'name')} />
            <select
              className="formsModal__idea__input formsModal__idea__input-select"
              required
              onChange={(e) => this.handleInput(e, 'join', 'prof')}
              value={this.state.join.prof}
              name="Вакансия">
              <option value="Frontend">{localStorage.getItem('lang') == 'ru'? 'Frontend':'Frontend'}</option>
              <option value="Design">{localStorage.getItem('lang') == 'ru'? 'Дизайн':'Design'}</option>
              <option value="Backend">Backend</option>
              <option value="Sales">{localStorage.getItem('lang') == 'ru'? 'Продажи':'Sales'}</option>
              <option value="Mobile">Mobile</option>

            </select>
            <input
              className={["formsModal__idea__input", this.state.join.touched.email && !this.state.join.valid.email ? "idea__input-invalid" : " "].join(" ")}
              type="email"
              required
              name="email"
              placeholder="Email"
              onChange={(e) => this.handleInput(e, 'join', 'email')}
              onBlur={() => this.handleTouched('join', 'email')} />
            <MaskedInput
              mask={['+', '7', ' ', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
              keepCharPositions={false}
              onBlur={() => this.handleTouched('join', 'phone')}
              onChange={(e) => this.handleInput(e, 'join', 'phone')}
              className={["formsModal__idea__input", this.state.join.touched.phone && !this.state.join.valid.phone ? "idea__input-invalid" : " "].join(" ")}
              type="text"
              name="phone"
              placeholder={localStorage.getItem('lang') == 'ru'? 'Телефон':'Phone'} />
            <div className={["idea__download__content idea__input-file__wrapper"].join(" ")}>
              <div className={["idea__input-file__button", this.props.theme === 'dark' ? "idea__input-file__button-dark" : ""].join(" ")}>
              {localStorage.getItem('lang') == 'ru'? 'Загрузить файл':'Upload file'}
                </div>
              <img className="idea__download__content-contact" src={downloadIcon} alt="" />
              <input
                id="file"
                type="file"
                name="file"
                onChange={(e) => this.handleFileInput(e, 'join')}
                className="formsModal__idea__input-file" />
              {this.state.join.file ?
                <div
                  onClick={() => this.handleFileDelete('idea')}
                  className={["idea__download__content__delete", this.props.theme === 'dark' ? "idea__download__content__delete-dark" : ""].join(" ")} >
                  <SVG src={deleteIcon} />
                </div> : null
              }
              {this.state.filename ?
                <span className={["idea__input-file__name", this.props.theme === 'dark' ? "idea__input-file__name-dark" : ""].join(" ")}>{this.state.filename}</span> :
                <span className={["idea__input-file__name", this.props.theme === 'dark' ? "idea__input-file__name-dark" : ""].join(" ")}>{localStorage.getItem('lang') == 'ru'? 'Выберите файл':'Select a file'}</span>}
            </div>
          </form>
          <div className="formsModal__idea__buttons">
            <Button handler={this.submitApplication}>{localStorage.getItem('lang') == 'ru'? 'Отправить':'Send'}</Button>
          </div>
        </div>)
      case 'qr':
        return (<div className="formsModal__qr">
          <div
            className="formsModal__idea__close"
            onClick={this.closeModal}>
            <SVG src={closeModal} />
          </div>
          <div className="formsModal__qr__item">
            <span className="formsModal__qr__item__title">{localStorage.getItem('lang') == 'ru'? 'QR code для скачивания Android':'QR code for Android download'}</span>
            <SVG src={qrCode} className="formsModal__qr__code" />
          </div>
          <div className="formsModal__qr__item">
            <span className="formsModal__qr__item__title">{localStorage.getItem('lang') == 'ru'? 'QR code для скачивания iOS':'QR code for iOS download'}</span>
            <SVG src={qrCode} className="formsModal__qr__code" />
          </div>
        </div>)
      case 'thanksPage':
      return (
        <div className="thanksPage" onClick={this.closeModal}>
          <div className="thanksPage__container">
            <div className="thanksPage__caption">{localStorage.getItem('lang') == 'ru'? 'Благодарим за выбор нашей компании!':'Thank you for choosing our company!'}</div>
            <div className="thanksPage__text">{localStorage.getItem('lang') == 'ru'? 'Менеджер свяжется с Вами в ближайшее время.':'A manager will contact you shortly.'}</div>
            <div className="thanksPage__button">
              <Button  onClick={this.closeModal}>Оk</Button>
            </div>

          </div>
        </div>
      )
      default:
        return null;
    }
  }

  render() {
    return (
      <div className="formsModal__wrapper">
        <Modal
          isOpen={this.props.formsModalIsOpen}
          onRequestClose={this.closeModal}
          style={customStyles}>
          <div
            className={["formsModal", this.props.formsModalTab === 'qr' ? "formsModal__qr__wrapper" : ""].join(" ")}
            style={{ padding: this.props.formsModalTab === 'qr' ? "0" : "0 102px" }}>
            {this.handleFormsTab(this.props.formsModalTab)}
          </div>
        </Modal>
      </div>)
  }
}

const mapStateToProps = ({ formsModalIsOpen, formsModalTab }) => {
  return {
    formsModalTab,
    formsModalIsOpen
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    toggleFormsModal: (flag, tab) => dispatch(toggleFormsModal(flag, tab))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FormsModal)



// WEBPACK FOOTER //
// ./src/components/formsModal/index.jsx